import React, { memo } from 'react'
import { WorkflowMode } from '../../models/Workflow';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from 'react-bootstrap';

type ModeProps = {
  mode: WorkflowMode;
  shadow?: boolean;
  small?: boolean;
}

export const ModeBadge = memo(({ mode, shadow, small }: ModeProps) => {
  const modeClass = mode.toLowerCase();
  const modeIcon = mode === WorkflowMode.BATCH ? solid('cog') : solid('align-left');

  return (
    <Badge bg="none" className={classNames('application-mode', { shadow, small }, modeClass)} pill={true}>
      <FontAwesomeIcon icon={modeIcon} />
      <span className="ms-2">{mode}</span>
    </Badge>
  )
});